import React from 'react';
import { Text, View, Keyboard } from 'react-native';
import { CodeField, Cursor, useBlurOnFulfill, useClearByFocusCell } from 'react-native-confirmation-code-field';

import { scale } from '@components/frame';
import { font } from '@styles/fonts';
import { isWeb } from '@helpers';

export default ({ count = 8, C, value, setValue }) => {
  const ref = useBlurOnFulfill({ value, cellCount: count });
  const [props, getCellOnLayoutHandler] = useClearByFocusCell({
    value,
    setValue,
  });

  return (
    <CodeField
      ref={ref}
      {...props}
      value={value}
      onChangeText={setValue}
      cellCount={count}
      keyboardType="default"
      textContentType="oneTimeCode"
      textInputStyle={
        isWeb && {
          border: 'none',
          outline: 'none',
        }
      }
      onSubmitEditing={Keyboard.dismiss}
      renderCell={({ index, symbol, isFocused }) => (
        <View
          key={`cell-${index}`}
          style={[
            {
              width: scale(41),
              height: scale(41),
              borderColor: C('Hairline/Light/No trans'),
              borderWidth: scale(1.5),
              justifyContent: 'center',
              alignContent: 'center',
              borderRadius: scale(8),
              backgroundColor: C('Background/Light/Field lighter'),
              marginRight: index + 1 === count ? 0 : scale(index + 1 === count / 2 ? 16 : 4),
            },
            isFocused && {
              borderColor: C('Fill/Light/Highlight'),
              borderWidth: scale(3),
            },
          ]}
        >
          <Text
            key={index}
            style={[
              font['Headline'],
              {
                textAlign: 'center',
                color: C('Label/Light/TV Primary'),
                textTransform: 'uppercase',
                fontSize: scale(30),
                lineHeight: scale(41),
                marginTop: scale(!symbol && isFocused ? (isWeb ? -7 : -5) : isWeb ? 0 : -2),
              },
            ]}
            onLayout={getCellOnLayoutHandler(index)}
          >
            {symbol || (isFocused ? <Cursor /> : null)}
          </Text>
        </View>
      )}
    />
  );
};
